import React, { FC } from "react";

import { useTranslation } from "react-i18next";

type FinanceProps = {
    details: MyBrokerApi.PersonalDetails;
};

const Finance: FC<FinanceProps> = ({ details = {} }) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.Finance.Type")}</span>
                <p>{details.bankAccount?.type?.name || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.Finance.Number")}</span>
                <p>{details.bankAccount?.number || "-"}</p>
            </div>
        </div>
    );
};

export default Finance;
